export default __webpack_public_path__ + "media/icons/log-out-icon-62b7d65b.svg";